import React, { useState } from 'react';
import SessionManager from '../../SessionManager';

function SetupStep({ onSetup }) {
  const [type, setType] = useState('team');
  const [ids, setIds] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const idList = ids.split('\n').map(id => id.trim()).filter(id => id !== '');
    onSetup(type, idList);
  };

  const handleNewSession = () => {
    const newSessionKey = `reconciliation_${type}_${Date.now()}`;
    const idList = ids.split('\n').map(id => id.trim()).filter(id => id !== '');
    const sessionData = {
      currentIndex: 0,
      savedData: [],
      type,
      ids: idList,
    };
    localStorage.setItem(newSessionKey, JSON.stringify(sessionData));
    onSetup(type, idList, newSessionKey);
  };

  const onResumeSession = (sessionData, sessionKey) => {
    console.log(sessionData, sessionKey);
    onSetup(sessionData.type, sessionData.ids, sessionKey, sessionData.currentIndex);
  };

  return (
    <div className="container mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4">Setup Reconciliation</h2>
      <form onSubmit={handleSubmit} className="mb-4">
        <div className="mb-4">
          <label className="block mb-2">Type:</label>
          <select
            value={type}
            onChange={(e) => setType(e.target.value)}
            className="w-full p-2 border rounded"
          >
            <option value="team">Team</option>
            <option value="person">Person</option>
          </select>
        </div>
        <div className="mb-4">
          <label className="block mb-2">IDs (one per line):</label>
          <textarea
            value={ids}
            onChange={(e) => setIds(e.target.value)}
            className="w-full p-2 border rounded"
            rows="4"
            placeholder="Enter IDs, one per line"
          ></textarea>
        </div>
        <button
          type="button"
          onClick={handleNewSession}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          Start New Session
        </button>
      </form>
      <SessionManager
        onResumeSession={onResumeSession}
        type={type}
      />
    </div>
  );
}

export default SetupStep;